import React from 'react';
import { Phone, Mail, MapPin, Globe, Download } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import gcacchiarelliDatos from '../assets/vcards/gcacchiarelli.vcf';
import gcacchiarelliFoto from '../assets/fotos/FOTO_GASTON.jpg';
import logoEnerbyte from '../assets/logos/Enerbyte_logo.png';
import enerbyteLogo from '../assets/logos/Enerbyte_logo_med.webp';

export default function ContactoGcacchiarelli() {
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = gcacchiarelliDatos;
        link.download = 'gcacchiarelli.vcf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div
            className="flex justify-center items-center min-h-screen bg-cover bg-center"
            style={{ backgroundColor: 'var(--background-color)' }}
        >
            <div className="backdrop-blur-md shadow-2xl rounded-2xl p-8 max-w-md w-full"
                style={{ backgroundColor: 'var(--background-color-typeA)' }}
            >
                <div className="flex flex-col items-center text-center space-y-4">
                <img
                        src={enerbyteLogo}
                        alt={"EnerByte"}
                        className="h-[2rem] w-fullobject-contain "
                    />
                    <p></p>
                    <img
                        src={gcacchiarelliFoto}
                        alt="Gastón Cacchiarelli"
                        className="w-28 h-28 rounded-full border-4  object-cover"
                        style={{ borderColor: 'var(--icon-color-eb)' }}
                    />

                    <h3 className="text-2xl font-bold leading-none  ">Ing. Gastón Cacchiarelli</h3>
                    <p className="mt-1" style={{marginTop:0}}>Cofundador </p>
                    
                    

                    <div className="text-left space-y-2 w-full"
                    style={{ color: 'var(--secondary-text-color)' }}>
                        <a href="tel:+5493498479604" className="flex items-center gap-2 hover:underline">
                            <Phone className="w-5 h-5 " 
                            style={{ color: 'var(--icon-color-eb)' }} 
                            /> +54 9 3498 479-604
                        </a>
                        <a href="mailto:gcacchiarelli@enerbyte.ar" className="flex items-center gap-2 hover:underline">
                            <Mail className="w-5 h-5 " style={{ color: 'var(--icon-color-eb)' }}
                            /> gcacchiarelli@enerbyte.ar
                        </a>
                        <a href="https://wa.me/5493498479604" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:underline">
                            <FaWhatsapp className="w-5 h-5 " style={{ color: 'var(--icon-color-eb)' }}
                            />+54 9 3498 479-604
                        </a>
                        <p className="flex items-center gap-2"><MapPin className="w-5 h-5 " style={{ color: 'var(--icon-color-eb)' }} 
                        />Argentina</p>
                        <a href="https://enerbyte.ar" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:underline">
                            <Globe className="w-5 h-5 " style={{ color: 'var(--icon-color-eb)' }}
                            /> EnerByte.ar
                        </a>
                    </div>

                    <button
                        onClick={handleDownload}
                        className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors mt-4"
                    >
                        <Download className="w-5 h-5" /> Agregar a contactos
                    </button>

                    <Link
                        to="/"
                        className="inline-block mt-2  hover:underline text-sm"
                        style={{ color: 'var(--secondary-text-color)' }}
                    >
                        ← Volver al sitio principal
                    </Link>
                </div>
            </div>
        </div>
    );
}
